export const Skins = () => {
    const FILL_COLOR = "white";
    // @TODO: Might be nice to do a matrix representation
    // Columns 0 to 13
    // Rows 0 to 6
    // Factors of multiplication: 0.5, 0.655, 0.835, 0.96, 1.125
    const GAP = 33;
    const RADIUS = 8.8;
    const Circle = ({ row, col, factor }) => (
        <circle
            r={RADIUS * factor}
            cx={(row * GAP) + 15.5}
            cy={(col * GAP) + 5.5}
            fill={FILL_COLOR}
        >
            <animate
                attributeName="opacity"
                values="0.5;1;0.5"
                dur={row * 1.3 + "s"}
                repeatCount="indefinite"
            />
        </circle>
    );
    return (
        <div className="absolute top-[50 %] left-[50 %] z-50 translate-x-[-50 %] translate-y-[-50 %] w-full h-full flex flex-col justify-center items-center bg-black / 75">
            <svg xmlns="http://www.w3.org/2000/svg" width="225" height="450">
                <Circle col={0} row={2} factor={0.5} />
                <Circle col={0} row={3} factor={0.5} />
                <Circle col={0} row={4} factor={0.5} />
                <Circle col={1} row={1} factor={0.655} />
                <Circle col={1} row={2} factor={0.655} />
                <Circle col={1} row={3} factor={0.655} />
                <Circle col={1} row={4} factor={0.655} />
                <Circle col={1} row={5} factor={0.655} />
                <Circle col={2} row={0} factor={0.5} />
                <Circle col={2} row={1} factor={0.655} />
                <Circle col={2} row={2} factor={0.835} />
                <Circle col={2} row={3} factor={0.835} />
                <Circle col={2} row={4} factor={0.835} />
                <Circle col={2} row={5} factor={0.655} />
                <Circle col={2} row={6} factor={0.5} />
                <Circle col={3} row={0} factor={0.5} />
                <Circle col={3} row={1} factor={0.655} />
                <Circle col={3} row={2} factor={0.835} />
                <Circle col={3} row={4} factor={0.835} />
                <Circle col={3} row={5} factor={0.655} />
                <Circle col={3} row={6} factor={0.5} />
                <Circle col={4} row={0} factor={0.5} />
                <Circle col={4} row={1} factor={0.655} />
                <Circle col={4} row={2} factor={0.835} />
                <Circle col={4} row={5} factor={0.655} />
                <Circle col={4} row={6} factor={0.5} />
                <Circle col={5} row={0} factor={0.5} />
                <Circle col={5} row={1} factor={0.655} />
                <Circle col={5} row={2} factor={1.125} />
                <Circle col={5} row={3} factor={0.835} />
                <Circle col={6} row={1} factor={0.655} />
                <Circle col={6} row={2} factor={1.125} />
                <Circle col={6} row={3} factor={1.125} />
                <Circle col={6} row={4} factor={0.835} />
                <Circle col={7} row={2} factor={0.835} />
                <Circle col={7} row={3} factor={1.125} />
                <Circle col={7} row={4} factor={1.125} />
                <Circle col={7} row={5} factor={0.655} />
                <Circle col={8} row={3} factor={0.835} />
                <Circle col={8} row={4} factor={1.125} />
                <Circle col={8} row={5} factor={0.655} />
                <Circle col={8} row={6} factor={0.5} />
                <Circle col={9} row={0} factor={0.5} />
                <Circle col={9} row={1} factor={0.655} />
                <Circle col={9} row={4} factor={1.125} />
                <Circle col={9} row={5} factor={0.655} />
                <Circle col={9} row={6} factor={0.5} />
                <Circle col={10} row={0} factor={0.5} />
                <Circle col={10} row={1} factor={0.655} />
                <Circle col={10} row={2} factor={0.96} />
                <Circle col={10} row={4} factor={1.125} />
                <Circle col={10} row={5} factor={0.655} />
                <Circle col={10} row={6} factor={0.5} />
                <Circle col={11} row={0} factor={0.5} />
                <Circle col={11} row={1} factor={0.655} />
                <Circle col={11} row={2} factor={0.96} />
                <Circle col={11} row={3} factor={0.96} />
                <Circle col={11} row={4} factor={0.96} />
                <Circle col={11} row={5} factor={0.655} />
                <Circle col={11} row={6} factor={0.5} />
                <Circle col={12} row={1} factor={0.655} />
                <Circle col={12} row={2} factor={0.655} />
                <Circle col={12} row={3} factor={0.655} />
                <Circle col={12} row={4} factor={0.655} />
                <Circle col={12} row={5} factor={0.655} />
                <Circle col={13} row={2} factor={0.5} />
                <Circle col={13} row={3} factor={0.5} />
                <Circle col={13} row={4} factor={0.5} />
            </svg>
        </div >
    )
}